export const apiUrl = process.env.REACT_APP_API_URL;
export const easContractAddress = process.env.REACT_APP_EAS_CONTRACT_ADDRESS;
export const easUId = process.env.REACT_APP_EAS_UID;
